export const _state = {
    isGetRegulationCategoriesFetch: false,
    isCreateRegulationCategoriesFetch: false,
    isUpdateRegulationCategoriesFetch: false,
    isDeleteRegulationCategoriesFetch: false,
    errors: {},
    regulation_category: {},
    regulation_categories: [],
};

export function regulationCategoriesReducer(state = _state, action) {

    switch (action.type) {

        case 'API_GET_REGULATION_CATEGORIES_CLOSE_FETCH':
            return {
                ...state,
                isGetRegulationCategoriesFetch: false,
            };

        case 'API_CREATE_REGULATION_CATEGORY_CLOSE_FETCH':
            return {
                ...state,
                isCreateRegulationCategoriesFetch: false,
            };

        case 'API_UPDATE_REGULATION_CATEGORY_CLOSE_FETCH':
            return {
                ...state,
                isUpdateRegulationCategoriesFetch: false,
            };

        case 'API_DELETE_REGULATION_CATEGORY_CLOSE_FETCH':
            return {
                ...state,
                isDeleteRegulationCategoriesFetch: false,
            };

        case 'API_GET_REGULATION_CATEGORIES':
            return {
                ...state,
                isGetRegulationCategoriesFetch: true,
            };

        case 'API_GET_REGULATION_CATEGORIES_SUCCESS':
            return {
                ...state,
                regulation_categories: action.payload.data,
                errors: {},
            };

        case 'API_GET_REGULATION_CATEGORIES_FAIL':
            return {
                ...state,
                errors: action.error.response.data
            };

        case 'API_CREATE_REGULATION_CATEGORY':
            return {
                ...state,
                isCreateRegulationCategoriesFetch: true,
            };

        case 'API_CREATE_REGULATION_CATEGORY_SUCCESS':
            return {
                ...state,
                regulation_category: {},
                errors: {},
            };

        case 'API_CREATE_REGULATION_CATEGORY_FAIL':
            return {
                ...state,
                errors: action.error.response.data
            };

        case 'API_UPDATE_REGULATION_CATEGORY':
            return {
                ...state,
                isUpdateRegulationCategoriesFetch: true,
            };

        case 'API_UPDATE_REGULATION_CATEGORY_SUCCESS':
            return {
                ...state,
                regulation_category: {},
                errors: {},
            };

        case 'API_UPDATE_REGULATION_CATEGORY_FAIL':
            return {
                ...state,
                errors: action.error.response.data
            };

        case 'API_DELETE_REGULATION_CATEGORY':
            return {
                ...state,
                isDeleteRegulationCategoriesFetch: true,
            };

        case 'API_DELETE_REGULATION_CATEGORY_SUCCESS':
            return {
                ...state,
                regulation_category: {},
                errors: {},
            };

        case 'API_DELETE_REGULATION_CATEGORY_FAIL':
            return {
                ...state,
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/regulation_categories.js